export const lyric05 = `I've been holding my breath
I've been counting to ten
Over something you said
I've been holding back tears
While you're throwing back beers
I'm alone in bed
You know I, I'm afraid of change
Guess that's why we stay the same
So tell me to leave
I'll pack my bags, get on the road
Find someone that loves you
Better than I do, darling, I know
'Cause you remind me every day
I'm not enough, but I still stay
Feels like a lifetime
Just trying to get by while we're dying inside
I've done a lot of things wrong
Loving you being one
But I can't move on
You know I, I'm afraid of change
Guess that's why we stay the same
So tell me to leave
I'll pack my bags, get on the road
Find someone that loves you
Better than I do, darling, I know
'Cause you remind me every day
I'm not enough, but I still stay
If you want me to leave
Then tell me to leave and baby I'll go
You remind me every day
I'm not enough, but I still stay`